import React, { useState } from "react";
import "../TicketsPage/WeatherTicket/style.scss";
import { BasketItem } from "../../models/BasketItem";
import useApiRequest from "../../../utils/hooks/useApiRequest";
import RealizeCodePanel from "../../../features/RealizeCodePanel";
import {USE_PASS} from "../../api/apiRoutes";

interface IProps {
  updateBasket: (basket: BasketItem[]) => void;
}

const RealizeVoucher: React.FC<IProps> = ({ updateBasket }: IProps) => {
  const { get } = useApiRequest();
  const [error, setError] = useState("");

  const onAccept = async (trhId: string) => {
    const { result, isError, errorTable } = await get(USE_PASS(trhId));
    if (!isError) {
      updateBasket(result.basket);
      setError("");
    } else {
      setError(errorTable);
    }
  };

  return (
    <RealizeCodePanel
      title={"Wykorzystaj wejście z voucheru"}
      inputPlaceholder={"Numer voucheru"}
      onAccept={(trhId: string) => onAccept(trhId)}
      errorText={error}
      isOpen
      isButtonOpen={false}
      description={
        "Voucher umożliwia wejście w wybranym dniu funkcjonowania Parku, zgodnie z zasadami realizacji vouchera. Wpisz numer vouchera w polu poniżej, aby otrzymać bilet wstępu."
      }
    />
  );
};

export default RealizeVoucher;
